import React from 'react';
import { initialsOf } from '@/lib/avatar';

// Displays a user's avatar image, or initials fallback.
export const UserAvatar = ({ src, name, size = 36, className = '' }) => {
  const dim = { width: `${size}px`, height: `${size}px` };
  if (src) {
    return <img src={src} alt={name || 'avatar'} style={dim} className={`rounded-full object-cover border border-white/10 ${className}`} />;
  }
  return (
    <div style={dim} className={`rounded-full bg-[#00B4D8]/15 text-[#48CAE4] flex items-center justify-center font-semibold ${className}`}>
      {initialsOf(name)}
    </div>
  );
};
